import { useState } from "react";
import { Icon, Sheet } from "@bd/ui-kit";
import { useGame } from "../store";
import { sendFeedback } from "../online/session";
import { t } from "../i18n";

/** Tell Anton what went wrong: the report goes with an exact copy of the game, so it can be replayed. */
export function Feedback() {
  const set = useGame((s) => s.set);
  const toast = useGame((s) => s.toast);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const send = async () => {
    setBusy(true);
    const e = await sendFeedback(text, "menu");
    setBusy(false);
    if (e) return setErr(e);
    toast({ title: t("Thanks! Feedback sent"), text: t("A copy of your game went with it."), tone: "good" });
    set({ screen: null });
  };
  return (
    <Sheet title={t("Feedback")} onClose={() => set({ screen: null })} testId="feedback"
      footer={<>
        {err && <span className="bad" style={{ marginRight: "auto" }} role="alert">{err}</span>}
        <button className="btn primary" disabled={busy || text.trim().length < 3} onClick={() => void send()} title={t("What happened, or what was confusing? A copy of your game goes too, so we see what you saw.")} data-testid="send-feedback"><Icon name="feedback" size={18} />{t("Send")}</button>
      </>}>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={6} maxLength={4000} placeholder={t("What happened? A copy of your game goes with it.")} aria-label={t("Send feedback")} style={{ width: "100%", resize: "vertical", font: "inherit", padding: "10px 12px", borderRadius: 12, border: "1.5px solid var(--line)", background: "#fff" }} data-testid="feedback-text" autoFocus />
    </Sheet>
  );
}
